import { render, staticRenderFns } from "./personalRank.vue?vue&type=template&id=a74b3d04&scoped=true&"
import script from "./personalRank.vue?vue&type=script&lang=js&"
export * from "./personalRank.vue?vue&type=script&lang=js&"
import style0 from "./personalRank.vue?vue&type=style&index=0&id=a74b3d04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74b3d04",
  null
  
)

export default component.exports